import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  standardColours,
  brandColours,
  fontSize,
} from '../styles';
import { Container } from './ui';

const StyledSitewideNotice = styled.div`
  position: relative;
  z-index: 3;
  padding: 12px 0;
  text-align: center;
  background-color: ${brandColours.primary};

  ${maxBreakpointQuery.mlarge`
    border-bottom: 1px solid ${standardColours.white};
  `}
`;

const StyledText = styled.div`
  p {
    color: ${standardColours.white};
    ${fontSize(14)};
    line-height: 1.5;

    ${minBreakpointQuery.small`
      ${fontSize(15)};
    `}

    ${minBreakpointQuery.large`
      ${fontSize(16)};
    `}

    a {
      text-decoration: underline;
    }
  }
`;

const SitewideNotice = () => {
  const {
    spaseekers: {
      promotion: { headerBanner },
    },
  } = useStaticQuery(graphql`
    query SitewideNoticeQuery {
      spaseekers {
        promotion {
          headerBanner {
            message
            linkText
            linkUrl
          }
        }
      }
    }
  `);

  let message, linkText, linkUrl;
  const enabled = !!headerBanner && !!headerBanner.message;
  if (enabled) {
    message = headerBanner.message;
    linkText = headerBanner.linkText;
    linkUrl = headerBanner.linkUrl;
  }

  return (
    enabled && (
      <StyledSitewideNotice>
        <Container>
          <StyledText>
            {message && (
              <p>
                {message}
                {linkText && (
                  <span>
                    &nbsp;&nbsp;<a href={linkUrl}>{linkText}</a>
                  </span>
                )}
              </p>
            )}
          </StyledText>
        </Container>
      </StyledSitewideNotice>
    )
  );
};

export default SitewideNotice;
